<template>
    <b-modal :id="'modal-deletar-arquivo-usuario'" hide-footer centered title="Excluir Arquivo">
        <div>
			<h4 class="mb-3">Você tem certeza que deseja excluir o arquivo ?</h4>
            <b-col md="12" class="d-flex gap-sm">
				{{ arquivo.nome + arquivo.extensao }}
            </b-col>
        </div>
        <div class="d-flex mt-5">
            <b-button variant="outline-danger" class="mx-auto" :disabled="carregando" @click="excluirArquivo">
                <b-spinner class="align-middle" variant="danger" v-show="carregando"></b-spinner>
					<span v-show="!carregando">
						Excluir
					</span>
            </b-button>
        </div>

    </b-modal>
</template>

<script>
import ArquivoUsuarioService from "../../service/ArquivoUsuarioService.js";

export default {
	name: "ModalExcluirArquivoUsuario",
	data() {
		return {
			carregando: false,
			arquivo: "",
		};
	},
	methods: {
		abrirModal(arquivo) {
			this.arquivo = arquivo;
			this.$bvModal.show("modal-deletar-arquivo-usuario");
		},
		excluirArquivo() {
			this.carregando = true;
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			ArquivoUsuarioService.deletar(this.arquivo.id, usuarioLogado.id)
				.then(() => {
					this.mensagem("Arquivo Deletado Com Sucesso!", "Sucesso", "success");
					this.$emit("input");
				}).catch((err) => {
					if (err.response.data) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível atualizar a descrição arquivo!", "Erro", "danger");
					}
				}).finally(() => {
					this.carregando = false;
					this.$bvModal.hide("modal-deletar-arquivo-usuario");
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/GerenciarArquivosUsuarios/ModalExcluirArquivoUsuario.vue